import { render, staticRenderFns } from "./ArticlesGlobal.vue?vue&type=template&id=497da650&"
import script from "./ArticlesGlobal.vue?vue&type=script&lang=js&"
export * from "./ArticlesGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports